import { registerBlockType } from '@wordpress/blocks';

// import './store';
// import './plugin';

import metadata from '../block.json';
import Edit from './edit';
import './editor.scss';
import { instagramIcon } from './utils/icons';

registerBlockType(metadata, {
	icon: instagramIcon(),

	// Build in Functions
	edit: Edit,

	save: () => null
});